import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useNavigate } from "react-router";

import { store } from "@src/index";
import { ISponsor } from "@src/types/api";

import { globalActions, selectSponsor } from "@features/global/globalSlice";

import { useAppDispatch } from "@hooks/reduxHooks";

import { AdvertiserInfoData } from "@SiteManagement/Advertisers/types/advertisers";

const useFormHandlers = (
    setSponsor: React.Dispatch<React.SetStateAction<ISponsor>>,
    setLogo: React.Dispatch<React.SetStateAction<File[]>>,
    methods: UseFormReturn<AdvertiserInfoData, any, undefined>,
) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const handleUpdate = (data: AdvertiserInfoData, logo: File[]) => {
        dispatch(
            globalActions.updateSponsor({
                sponsorId: data.id as number,
                name: data.name,
                link: data.link,
                logo,
            }),
        )
            .unwrap()
            .then(response => {
                const sponsor = selectSponsor(store.getState(), response.id);
                sponsor && setSponsor(sponsor);
                methods.reset();
                setLogo([]);
            });
    };

    const handleCreate = (data: AdvertiserInfoData, logo: File[]) => {
        dispatch(
            globalActions.createSponsor({
                name: data.name,
                link: data.link,
                logo,
            }),
        )
            .unwrap()
            .then(response => {
                const sponsor = selectSponsor(store.getState(), response.id);
                sponsor && setSponsor(sponsor);
                methods.reset();
                setLogo([]);
                navigate(`/site-management/advertisers/${response.id}`);
            });
    };

    const handleDelete = (id: ISponsor["id"]) => {
        dispatch(globalActions.deleteSponsor({ id }))
            .unwrap()
            .then(response => {
                methods.reset();
                setLogo([]);
                navigate(`/site-management/advertisers`);
            });
    };

    return { handleUpdate, handleCreate, handleDelete };
};

export default useFormHandlers;
